module.exports = __webpack_public_path__ + "static/media/asento.2e44060c.jpg";